import React, { useState, useEffect } from 'react';
import MobileHero from '../../components/mobile/MobileHero';
import MobileRecentEpisode from '../../components/mobile/MobileRecentEpisode';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { Episode } from '../../types/types';
import { EpisodeService } from '../../services/EpisodeService';
import { Helmet } from 'react-helmet-async';
import './MobileHome.css';

const MobileHome = () => {
  const [recentEpisode, setRecentEpisode] = useState<Episode | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useScrollAnimation([]);

  useEffect(() => {
    const fetchRecentEpisode = async () => {
      try {
        setLoading(true);
        const episode = await EpisodeService.getRecentEpisode();
        setRecentEpisode(episode);
      } catch (err) {
        console.error('Error fetching recent episode:', err);
        setError('Failed to load recent episode');
      } finally {
        setLoading(false);
      }
    };

    fetchRecentEpisode();
  }, []);

  // Generate JSON-LD schema for the podcast
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "PodcastSeries",
    "name": "Basketball Culture Podcast",
    "description": "A podcast about basketball culture, featuring discussions about the NBA, European basketball, and streetball.",
    "url": "https://basketballculture.tv",
    "author": {
      "@type": "Person",
      "name": "Basketball Culture Podcast"
    }
  };

  if (recentEpisode) {
    Object.assign(jsonLd, {
      "episode": [{
        "@type": "PodcastEpisode",
        "name": recentEpisode.title,
        "datePublished": recentEpisode.date,
        "timeRequired": recentEpisode.duration,
        "url": `https://www.youtube.com/watch?v=${recentEpisode.videoId}`
      }]
    });
  }

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    backgroundColor: '#000',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    zIndex: 1
  };

  const contentStyle: React.CSSProperties = {
    flex: 1,
    width: '100%',
    padding: '1rem',
    position: 'relative',
    zIndex: 2
  };

  return (
    <div className="mobile-home" style={containerStyle}>
      <Helmet>
        <title>Basketball Culture Podcast - Home</title>
        <meta name="description" content="Welcome to Basketball Culture Podcast - Exploring the intersection of basketball and culture." />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <MobileHero />
      
      <div style={contentStyle}>
        {loading ? (
          <div className="mobile-loading" style={{ textAlign: 'center', padding: '2rem', color: '#fff' }}>
            Loading recent episode...
          </div>
        ) : error ? (
          <div className="mobile-error" style={{ textAlign: 'center', padding: '2rem', color: '#ff4444' }}>
            {error}
          </div>
        ) : recentEpisode ? (
          <MobileRecentEpisode episode={recentEpisode} />
        ) : (
          <div className="mobile-no-episode" style={{ textAlign: 'center', padding: '2rem', color: '#fff' }}>
            No recent episode available
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileHome; 